import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { getStatusColor } from '../../utils/helpers';

const StatusBar = ({ currentSlot, stats, sessionId, connectionStatus, isMobile }) => {
    const { theme } = useTheme();

    return (
        <div style={{
            alignContent: 'center',
            backgroundColor: theme.accent,
            animation: 'bubbleAppear 0.5s ease-in-out',
            boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
            minHeight: isMobile ? '80px' : '102px',
            marginBottom: isMobile ? '24px' : '34px',
            textAlign: 'center',
            borderRadius: '5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: isMobile ? '12px 17px' : '0 34px',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '12px' : '34px'
        }}>
            <div style={{
                display: 'flex',
                gap: isMobile ? '17px' : '34px',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center',
                textAlign: 'center'
            }}>
                <span style={{
                    fontWeight: 'bolder',
                    textTransform: 'uppercase',
                    color: theme.statusBarText,
                    fontSize: isMobile ? '18px' : '23px'
                }}>
                    Current Slot: {currentSlot}
                </span>
                <span style={{
                    fontWeight: 'bolder',
                    textTransform: 'uppercase',
                    color: theme.statusBarText,
                    fontSize: isMobile ? '18px' : '23px'
                }}>
                    Auctions: {stats.active_jit_auctions + stats.active_aot_auctions}
                </span>
                <span style={{
                    fontWeight: 'bolder',
                    textTransform: 'uppercase',
                    color: theme.statusBarText,
                    fontSize: isMobile ? '18px' : '23px'
                }}>
                    Transactions: {stats.total_transactions}
                </span>
            </div>
            <div style={{
                display: 'flex',
                gap: isMobile ? '12px' : '17px',
                alignItems: 'center',
                flexDirection: isMobile ? 'column' : 'row'
            }}>
                <span style={{
                    fontSize: isMobile ? '15px' : '21px',
                    color: theme.statusBarText,
                    opacity: '0.8',
                    fontWeight: 'bold'
                }}>
                    Session: {sessionId ? sessionId.slice(0, 8) + '...' : 'None'}
                </span>
                <span style={{
                    fontSize: isMobile ? '12px' : '14px',
                    color: theme.statusBarText,
                    backgroundColor: getStatusColor(connectionStatus),
                    padding: '4px 8px',
                    borderRadius: '3px',
                    textTransform: 'uppercase',
                    fontWeight: 'bold'
                }}>
                    {connectionStatus}
                </span>
            </div>
        </div>
    );
};

export default StatusBar;
